import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { AllRequestsViewModalComponent } from './all-requests-view-modal/all-requests-view-modal.component';
import { FundRequestModalComponent } from './fund-request-modal/fund-request-modal.component';
import { ReturnRetrivalModalComponent } from './return-retrival-modal/return-retrival-modal.component';
import { FundReturnRetrivalModalComponent } from './fund-return-retrival-modal/fund-return-retrival-modal.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-ist-all-requests',
  templateUrl: './ist-all-requests.component.html',
  styleUrls: ['./ist-all-requests.component.scss']
})
export class IstAllRequestsComponent implements OnInit {
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  productlist: any = [];
  statuslist: any = [];
  AllRequestSearch: UntypedFormGroup;
  permission: string = "";
  isFundBasedApp: string = "";
  userType: string = "";
  IsPatientsAvailable = "yes";
  typeOptions = [];
  AppStatus:any;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    this.permission = this.commonService.getPagePermission("IST07").toLowerCase();
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      const modalRef = this.modalService.open(MessageBoxComponent, {   });
      modalRef.componentInstance.Content={ heading: '', content: { heading: '', description: 'Please save General information details to navigate to All Requests', operation: { hasConfirm: false } } }
      modalRef.result.then((result) => {
        this.router.navigate(['/home/ist/my-applications/application-ext/:' + this.ApplicationID + '/general_information_request'],
          { skipLocationChange: true, queryParams: { id: this.ApplicationID, app_ext: true, module: "ist", screen_type: "my-applications" } })
      });
      return false;
    }
    this.AppStatus =this.commonService.getIstStatus();
    this.userType = this.userService.getUserType();
    this.AllRequestSearch = new UntypedFormGroup({
      RequestID: new UntypedFormControl(null),
      ProductName: new UntypedFormControl(null),
      RequestType: new UntypedFormControl(null),
      Status: new UntypedFormControl(""),
    });

    this.productlist = [];

    this.statuslist = [
      { "value": "", "label": "All" },
      { "value": "1", "label": "Draft" },
      { "value": "2", "label": "Submitted" },
      { "value": "3", "label": "Approved" },
      { "value": "4", "label": "Rejected" },
      { "value": "5", "label": "Allocated" },
      { "value": "8", "label": "Withdrawn" },
      { "value": "7", "label": "Closed" },
      { "value": "10", "label": "Return Requested" }      
    ];

    this.typeOptions = [
      { "value": "", "label": "Both" },
      { "value": "Product", "label": "Product" },
      { "value": "Fund", "label": "Fund" }
    ];

    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });

    this.tempoperations = [

    ];
    // onSetGridApi(params) {
    //   this.gridApi = params.api;
    //   this.gridApi.sizeColumnsToFit();
    // }

    // if (this.permission == "edit") {
    //   this.tempoperations.push({
    //     "name": "Edit",
    //     "id": "edit"
    //   });

    // }

    this.advanceSearch = {

    };

    // this.operations = this.tempoperations.map(operation => {
    //   return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    // });


    this.getMasterData();
    this.getSummary();


  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
    this.gridApi.sizeColumnsToFit();
  }

  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.modalService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    if (event.data['RequestType'] == "Product") {
      let modalRef = this['self'].modalService.open(AllRequestsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: 'View',
        content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
      }
      //modalRef.content.action.subscribe(result => {
      //  this['self'].getSummary();
      //})
    } else {
      let modalRef1 = this['self'].modalService.open(FundRequestModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef1.componentInstance.Content= {
        heading: 'View',
        content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
      }
      //modalRef1.content.action.subscribe(result => {
      //  this['self'].getSummary();
      //})
    }

  }

  add_product_request() {
    // if (this.IsPatientsAvailable != "no") {
    let modalRef = this.modalService.open(AllRequestsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this.getSummary();
    })
    // }
    // else {
    //   this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Please save the Patients first.' } } });
    // }
  }

  edit(summay, modalserive) {
    if (this['self'].selectedRow['RequestType'] == "Product") {
      let modalRef = this['self'].modalService.open(AllRequestsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true,
      });
        modalRef.componentInstance.Content={
          heading: 'Edit',
          content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
        }
      modalRef.result.then(result => {
        this['self'].getSummary();
      })
    }
    else {
      let modalRef = this['self'].modalService.open(FundRequestModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true,
      });
        modalRef.componentInstance.Content={
          heading: 'Edit',
          content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
        }
      modalRef.result.then(result => {
        this['self'].getSummary();
      })
    }

  }

  getMasterData() {
    this.summaryService.getSummaryData("api/ISTAllRequests/GetSummaryMaster?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.productlist = summary["MasterData1"];
      this.productlist = [{ label: "All", value: null, checked: true }].concat(this.productlist);
      if (summary["MasterData2"] != null && summary["MasterData2"] != undefined) {
        this.isFundBasedApp = summary["MasterData2"][0].value;
      }

      if (summary["MasterData3"] != null && summary["MasterData3"] != undefined) {
        this.IsPatientsAvailable = summary["MasterData3"][0].value;
      }

      if (this.isFundBasedApp == "3") {
        this.columnDefs = [
          {
            "headerName": "Request Type",
            "field": "RequestType"
          },
          {
            "headerName": "Product Name",
            "field": "ProductName"            
          },
          {
            "headerName": "Requested",
            "field": "Requested"
          },
          {
            "headerName": "Allocated",
            "field": "Allocated"
          },
          {
            "headerName": "Used",
            "field": "Used"
          },
          {
            "headerName": "Status",
            "field": "StatusStr"
          }
        ];
      } else {
        this.columnDefs = [
          {
            "headerName": "Product Name",
            "field": "ProductName"
          },
          {
            "headerName": "Requested",
            "field": "Requested"
          },
          {
            "headerName": "Allocated",
            "field": "Allocated"
          },
          {
            "headerName": "Used",
            "field": "Used"
          },
          {
            "headerName": "Status",
            "field": "StatusStr"
          }
        ];
      }

      if (window && window['moduleType'] && window['moduleType'] == "eap") {
        this.operations.map((columnDef, i) => {
          if (columnDef.name === "Add Fund Request") {
            delete this.operations[i]
          }
        })
      }
    });
  }

  getSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData("api/ISTAllRequests/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {

      this.rowData = this.setOperations(summary);
    });
  }

  setOperations(RawData: any): any {

    this.setDef(this.tempoperations);
    RawData.forEach(element => {  

      if (element.StatusStr == "Submitted" && this.userType == "I") {
        let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Approve",
            "id": "approve"
          },
          {
            "name": "Reject",
            "id": "reject"
          }
        ];

        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.StatusStr == "Approved" && this.userType == "I") {
        let tempoperations2
        tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Allocate",
            "id": "allocate"
          }
        ];

        element["Operations"] = this.setDef(tempoperations2);
      }

      if ((element.StatusStr == "Allocated" || element.StatusStr == "Return Requested")&& this.userType == "I") {
        let tempoperations2 = [ ];

        if (element.Used != null && element.Used != undefined && element.Used != "" && (element.RetrivalQuantity == null ||  element.RetrivalQuantity == "" ||  element.RetrivalQuantity == undefined)) {
          tempoperations2.push(            
            {
              "name": "View",
              "id": "view"
            },
            {
            "name": "Retrieve",
            "id": "retrieve"
            }
          );
        }

        if( (element.Used == null || element.Used == undefined || element.Used == "") && element.StatusStr == "Allocated"){
          tempoperations2.push({
            "name": "View",
            "id": "view"
          });

          element["Operations"] = this.setDef(tempoperations2);
        }

        if((element.StatusStr == "Return Requested" || element.StatusStr == "Allocated") &&  element.RetrivalQuantity != null &&  element.RetrivalQuantity != "" &&  element.RetrivalQuantity != undefined){
          tempoperations2.push({
            "name": "View",
            "id": "view"
          });
        }

        element["Operations"] = this.setDef(tempoperations2);
      }
      
      if (element.StatusStr == "Returned" && this.userType == "I") {
        if ((element.returnFund != null && element.returnFund != "")) {
          let tempoperations2 = [
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Close",
              "id": "close"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);
        }
      }

      if (element.StatusStr == "Draft" && this.userType == "E") {
        if (this.permission == "new" || this.permission == "edit") {
          this.tempoperations = [
            {
              "name": "Edit",
              "id": "edit"
            },
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Delete",
              "id": "delete"
            }
            
          ];
    
          if(this.AppStatus)
            {
              this.tempoperations.push(
                {
                  "name": "Submit",
                  "id": "submit"
                }
              )
             }

        } 

        element["Operations"] = this.setDef(this.tempoperations);
      }      

      if (element.StatusStr == "Submitted" && this.userType == "E") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Withdraw",
            "id": "withdraw"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if ((element.StatusStr == "Approved" || element.StatusStr == "Allocated") && this.userType == "E") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];      
         

        if ((element.Used == null || element.Used == "" || element.Used == undefined) && element.StatusStr == "Allocated") {
          this.tempoperations.push(            
            {
              "name": "Edit",
              "id": "edit"
            },
            {
              "name": "Withdraw",
              "id": "withdraw"
            },
            {
              "name": "Request Return",
              "id": "requestReturn"
            }
          );
        }

        if (element.StatusStr == "Approved") {
          this.tempoperations.push(   
            {
              "name": "Withdraw",
              "id": "withdraw"
            }
          );
        }

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.StatusStr == "Return Requested"  && this.userType == "E"){
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.StatusStr == "Returned"  && this.userType == "E"){
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Withdraw",
            "id": "withdraw"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }
      
      if (element.RetrivalQuantity != null && element.RetrivalQuantity != "" && element.RetrivalQuantity != undefined && (element.StatusStr == "Allocated" || element.StatusStr == "Return Requested") && this.userType == "E") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          },         
          {
            "name": "Return",
            "id": "returnrequest"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.StatusStr == "Closed" || element.StatusStr == "Withdrawn" || element.StatusStr == "Rejected") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.Allocated != null && element.Allocated != "" && element.Allocated != undefined &&
        element.Used != null && element.Used != "" && element.Used != undefined) {
        if (element.Allocated == element.Used && this.userType=="I") {
          let tempoperations2 = [
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Close",
              "id": "close"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);
        }
      }

      if (this.permission == "view") {
        this.tempoperations = [          
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      } 
       
    });
    return RawData;
  }

  setDef(parmoperations: any): any {
    //this.tempoperations = parmoperations;
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  setSummarySearch(searchObject) {
    this.summaryService.fetchSearchData("api/ISTAllRequests/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = summary;
    });
  }

  add_fund_request() {
    let modalRef = this.modalService.open(FundRequestModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }

    }
    modalRef.result.then(result => {
      this.getSummary();
    })
  }

  view(summary, modalserive) {
    if (this['self'].selectedRow['RequestType'] == "Product") {
      let modalRef = this['self'].modalService.open(AllRequestsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true,
      });
      modalRef.componentInstance.Content= {
          heading: 'View',
          content: {
            id: this['self'].selectedRow['ID'],
            ReturnAmount: this['self'].selectedRow['WithOutSymbolUsed'] == null? this['self'].selectedRow['WithOutSymbolAllocated'] : this['self'].selectedRow['WithOutSymbolAllocated'] - this['self'].selectedRow['WithOutSymbolUsed'],
            RetrieveVia: this['self'].selectedRow['RetrieveType'],
            UsedFund: this['self'].selectedRow['Used'],
            ReturnFund: this['self'].selectedRow['returnFund']
          }
        }

    } else {
      let modalRef1 = this['self'].modalService.open(FundRequestModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true,
      });
        modalRef1.componentInstance.Content={
          heading: 'View',
          content: {
            id: this['self'].selectedRow['ID'],
            ReturnAmount: this['self'].selectedRow['WithOutSymbolUsed'] == null? this['self'].selectedRow['WithOutSymbolAllocated'] : this['self'].selectedRow['WithOutSymbolAllocated'] - this['self'].selectedRow['WithOutSymbolUsed'],
            RetrieveVia: this['self'].selectedRow['RetrieveType'],
            UsedFund: this['self'].selectedRow['Used'],
            ReturnFund: this['self'].selectedRow['returnFund']
          }
        }

    }
  }

  delete(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] < 2) {
      let id = this['self'].selectedRow['ID'];
      let Type = this['self'].selectedRow['RequestType'];
      let modalRef = this["self"].modalService.open(DeleteBoxComponent,  {backdrop: false});
      modalRef.componentInstance.Content= { heading: 'Delete',custommessage: 'Are you sure you want to delete the ' + Type + ' request?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel"};
      modalRef.result.then(result => {
        if (result == "okclick") {
          summarySer.DeleteRecord('api/ISTAllRequests/Delete?RecordID=' + id).subscribe(summary => {
            if (summary["Status"] == 0) {
              // this['self'].toastrService.success("Selected Record(s) has been Deleted.");
              this['self'].commonService.SuccessBanner("Request has been deleted successfully")
              this['self'].getSummary();
            }
            else {
              //this['self'].toastrService.error("Error Occurred while Deleting the record.Please try again after sometime.");
              this.commonService.ErrorBanner("Error Occurred while Deleting the record.Please try again after sometime.");
            }
          });
        }
      });
    }
    else {
      //this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
      this.commonService.ValidationBanner("The submitted request cannot be deleted");
      // this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'The submitted request cannot be delete' } } });
    }
  }

  approve(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] == 2) {
      summarySer.getSummaryData("api/ISTAllRequests/Approve?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
        // this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        //   backdrop: false,
        //   keyboard: false,
        //   ignoreBackdropClick: true,
        //   animated: true,
        //   // data: { heading: 'Approve', content: { heading: '', description: 'The request has been Approved.' } }
        // });
        this['self'].commonService.SuccessBanner("Request has been approved");
        this['self'].getSummary();
      })
    }
    else {
      this['self'].commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }

  }

  submit(summarySer, modalserive) {
    // || (this['self'].selectedRow['ParentId'] != undefined && this['self'].selectedRow['RequiredBy'] <= Date.now)
    if (this['self'].selectedRow['Status'] < 2) {
      summarySer.getSummaryData("api/ISTAllRequests/Submit?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
        // this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        //   backdrop: false,
        //   keyboard: false,
        //   ignoreBackdropClick: true,
        //   animated: true,
        //   data: { heading: 'Approve', content: { heading: '', description: 'The request has been Submitted.' } }
        // });
        this['self'].commonService.SuccessBanner("Request has been Submitted")
        this['self'].getSummary();
      })
    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  reject(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] == 2) {

      summarySer.getSummaryData("api/ISTAllRequests/Reject?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
        // this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        //   backdrop: false,
        //   keyboard: false,
        //   ignoreBackdropClick: true,
        //   animated: true,
        //   // data: { heading: 'Reject', content: { heading: '', description: 'The request has been Rejected.' } }
        // });
        this['self'].commonService.SuccessBanner("Request has been rejected");
        this['self'].getSummary();
      });
    }
    else {
      this['self'].commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }

  }

  requestReturn(summarySer, modalserive) {
    let modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
    if (this['self'].selectedRow['RequestType'] == "Product") {
      modalRef.componentInstance.Content = { header: 'Confirmation', custommessage: 'Do you want to return the product?', ProceedButtonName: "Yes", TerminateButtonName: "No"  };
    } else {
      modalRef.componentInstance.Content = { header: 'Confirmation', custommessage: 'Do you want to return the fund?', ProceedButtonName: "Yes", TerminateButtonName: "No"  };
    }
    modalRef.result.then(result => {
      if (result == "okclick") {
        summarySer.getSummaryData("api/ISTAllRequests/RequestReturn?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
          this['self'].commonService.SuccessBanner("Return request submitted successfully");
          this['self'].getSummary();
        });
      }
    });
  }

  close(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] > 3) {
      const modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
      modalRef.componentInstance.Content={ header: 'Close', custommessage: 'You are about to close the request. Do you want to proceed?', ProceedButtonName: "Yes", TerminateButtonName: "Cancel" };
      modalRef.result.then(result => {
        if (result == "okclick") {
          summarySer.getSummaryData("api/ISTAllRequests/Close?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
            if (summary != null && summary.Message == "N") {
              if (this['self'].selectedRow['RequestType'] == "Product") {
                this.commonService.ValidationBanner("Selected operation is not Possible Please Adjust Product ");
                // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible Please Adjust Product .' } } });

              }
              else {
                this.commonService.ValidationBanner("Selected operation is not Possible Please Adjust Fund");
                // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible Please Adjust Fund.' } } });
              }
            }
            else {
              this['self'].commonService.SuccessBanner("The request has been closed");
              this['self'].getSummary();
            }

          });
        }
      });
    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }

  }

  allocate(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] == 3) {
      if (this['self'].selectedRow["Allocated"] != null && this['self'].selectedRow["Allocated"] != "" && this['self'].selectedRow["Allocated"] != undefined) {
        summarySer.getSummaryData("api/ISTAllRequests/Allocate?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
          // this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
          //   backdrop: false,
          //   keyboard: false,
          //   ignoreBackdropClick: true,
          //   animated: true,
          //   // data: {
          //   //   heading: 'Allocated',
          //   //   content: { heading: '', description: 'The product request has been Allocated.' }
          //   // }
          // });
          this['self'].commonService.SuccessBanner("Request details updated successfully");
          this['self'].getSummary();
        });
      }
      else {
        if (this['self'].selectedRow['RequestType'] == "Product") {
          let modalRef = this['self'].modalService.open(AllRequestsViewModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-vlg right modal-right',
            animation: true,
          });
            modalRef.componentInstance.Content= {
              heading: 'Allocate',
              content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID, AllocatedAmount: this["self"].selectedRow["Allocated"] }
            }
          modalRef.result.then(result => {
           // if (result.Status == 0) {
              // summarySer.getSummaryData("api/ISTAllRequests/Allocate?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {

              //   //this['self'].commonService.SuccessBanner("Request details updated successfully");
              //   this['self'].getSummary();
              // });
              this['self'].getSummary();
           // }
          })
        }
        else {
          let modalRef = this['self'].modalService.open(FundRequestModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-vlg right modal-right',
            animation: true,
          });
            modalRef.componentInstance.Content= {
              heading: 'Allocate',
              content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID, AllocatedAmount: this["self"].selectedRow["Allocated"] }
            }
          modalRef.result.then(result => {
          //  if (result.Status == 0) {
              // summarySer.getSummaryData("api/ISTAllRequests/Allocate?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {

              //   //this['self'].commonService.SuccessBanner("Request details updated successfully");
              //   this['self'].getSummary();
              // });
              this['self'].getSummary();
           // }            
          })
        }
      }


    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  returnrequest(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] == 5 || this['self'].selectedRow['Status'] == 10) {
      if (this['self'].selectedRow["returnFund"] != null && this['self'].selectedRow["returnFund"] != "" && this['self'].selectedRow["returnFund"] != undefined) {
        this.commonService.SuccessBanner("Return details shared successfully");
        this['self'].getSummary();
      }
      else {
        if (this['self'].selectedRow['RequestType'] == "Product") {
          let modalRef = this['self'].modalService.open(AllRequestsViewModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-vlg right modal-right',
            animation: true,
          });
            modalRef.componentInstance.Content={
              heading: 'Return',
              content: {
                id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID,
                ReturnAmount: this['self'].selectedRow['WithOutSymbolUsed'] == null? this['self'].selectedRow['WithOutSymbolAllocated'] : this['self'].selectedRow['WithOutSymbolAllocated'] - this['self'].selectedRow['WithOutSymbolUsed'],
                RetrieveVia: this['self'].selectedRow['RetrieveType']
              }
            }
          modalRef.result.then(result => {
            if (result.Status == 0) {
              // summarySer.getSummaryData("api/ISTAllRequests/ReturnRequest?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
              //   this['self'].getSummary();
              // });
              this['self'].getSummary();
            }
          })
        }
        else {
          let modalRef = this['self'].modalService.open(FundRequestModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-vlg right modal-right',
            animation: true,
          });
            modalRef.componentInstance.Content={
              heading: 'Return',
              content: {
                id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID,
                ReturnAmount:this['self'].selectedRow['WithOutSymbolUsed'] == null? this['self'].selectedRow['WithOutSymbolAllocated'] : this['self'].selectedRow['WithOutSymbolAllocated'] - this['self'].selectedRow['WithOutSymbolUsed'],
                UsedFund: this['self'].selectedRow['Used'],
                RetrieveVia: this['self'].selectedRow['RetrieveType']
              }
            }
          modalRef.result.then(result => {
            if (result.Status == 0) {
              // summarySer.getSummaryData("api/ISTAllRequests/ReturnRequest?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
              //   this['self'].getSummary();
              // });
              this['self'].getSummary();
            }
          })
        }
      }
    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  retrieve(summary, modalserive) {
    if (this['self'].selectedRow['Status'] == 5 || this['self'].selectedRow['Status'] == 10) {
      if (this['self'].selectedRow['RequestType'] == "Product") {
        let modalRef = this['self'].modalService.open(ReturnRetrivalModalComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-md right modal-right',
          animation: true,
        });
          modalRef.componentInstance.Content={
            heading: null,
            content: {
              id: this['self'].selectedRow['ID'],
              ApplicationID: this.ApplicationID,
              Allocated: this["self"].selectedRow["Allocated"],
              ProductUnits: this["self"].selectedRow["ProductUnits"],
              ReturnAmount: this['self'].selectedRow['WithOutSymbolUsed'] == null? this['self'].selectedRow['WithOutSymbolAllocated'] : this['self'].selectedRow['WithOutSymbolAllocated'] - this['self'].selectedRow['WithOutSymbolUsed'],
            }
          }
        modalRef.result.then(result => {
          this['self'].getSummary();
        })
      }
      else {
        let modalRef = this['self'].modalService.open(FundReturnRetrivalModalComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-md right modal-right',
          animation: true,
        });
          modalRef.componentInstance.Content= {
            heading: null,
            content: {
              id: this['self'].selectedRow['ID'],
              ApplicationID: this.ApplicationID,
              Allocated: this["self"].selectedRow["WithOutSymbolAllocated"],
              ReturnAmount: this['self'].selectedRow['WithOutSymbolUsed'] == null? this['self'].selectedRow['WithOutSymbolAllocated'] : this['self'].selectedRow['WithOutSymbolAllocated'] - this['self'].selectedRow['WithOutSymbolUsed'],
            }
          }
        modalRef.result.then(result => {
          this['self'].getSummary();
        })
      }

    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  retrieve_fund() {
    let modalRef = this['self'].modalService.open(FundReturnRetrivalModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true,
    });
      modalRef.componentInstance.Content= {
        heading: null,
        content: { id: this['self'].selectedRow['ID'] }

      }
  }

  withdraw(summarySer, modalserive) {
    // if (this['self'].selectedRow['Status'] == ) {
      if(this['self'].selectedRow['Status'] == 5 || this['self'].selectedRow['Status'] == 6){
        if (this['self'].selectedRow['RequestType'] == "Product"){
          this['self'].commonService.ValidationBanner("To withdraw the request please raise return request for the allocated Product");
        } else{
          this['self'].commonService.ValidationBanner("To withdraw the request please raise return request for the allocated Fund");
        }
      } else{
        summarySer.getSummaryData("api/ISTAllRequests/WithDraw?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
          this['self'].commonService.SuccessBanner("The request has been withdrawn Successfully");
          this['self'].getSummary();
        });
      }
    
    // }
    // else {
    //   modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    // }
  }


  

  SearchClear() {
    this.AllRequestSearch.reset();
    //  this.setSummary();
  }

  AdvanceSearch() {
    var formData = this.AllRequestSearch.value;
    formData["ApplicationID"] = this.ApplicationID;
    if (formData["Status"] != "" && formData["Status"] != undefined && formData["Status"] != null) {
      formData["Status"] = parseInt(formData["Status"]);
    }
    this.setSummarySearch(formData);
  }
}
